module.exports = __webpack_public_path__ + "img/logo-footer-5.d6309ad2.png";